let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("alCdn")).then(() => parcelRequire('jU4oh'));